// Detects drinks/liquids by name so quantity labels show "ml" instead of "g".
// Density of most drinks ≈ 1, the stored number stays identical.
const LIQUID_RE = new RegExp(
  [
    "cola", "pepsi", "fanta", "sprite", "soda", "limonade", "limonata", "lemonade",
    "wasser", "water", "acqua", "eau", "mineral",
    "saft", "juice", "succo", "jus", "schorle", "nektar", "nectar",
    "tee", "tea", "tè", "thé", "eistee", "ice tea", "iced tea",
    "kaffee", "coffee", "caffè", "caffe", "café", "espresso", "cappuccino", "latte macchiato",
    "milch", "milk", "latte\\b", "lait", "drink",
    "bier", "beer", "birra", "bière", "wein", "wine", "vino", "vin\\b", "prosecco", "sekt", "spritz",
    "smoothie", "shake", "frappè", "frappe", "getränk", "bevanda", "boisson", "beverage",
    "energy", "red bull", "redbull", "isotonic", "iso\\b", "kombucha",
    "bouillon", "brühe", "brodo", "bouillon", "suppe", "soup", "zuppa",
    "sirup", "syrup", "kakao", "cocoa", "cioccolata calda", "ovomaltine",
  ].join("|"),
  "i"
);

export const isLiquidName = (name) => LIQUID_RE.test(String(name || ""));

export const unitFor = (name) => (isLiquidName(name) ? "ml" : "g");
